import { useSelector } from "react-redux"
import { RootState } from "../store"
import React from 'react';
import { useTranslation } from "react-i18next";

interface VerifyNoticeProps {
  showModal: () => void;
}

const VerifyNotice: React.FC<VerifyNoticeProps> = ({ showModal }) => {
  const Organization = useSelector((state: RootState) => state.auth.org);
  const { t } = useTranslation();

  if (Organization?.isVerified || Organization?.email?.endsWith("@roaait.com")) {
    return <></>;
  }

  return (
    <div className="mx-3 mb-2 p-3 rounded-xl bg-amber-50 border border-amber-200 flex items-center gap-2">
      <span className="flex-shrink-0 bg-amber-100 text-amber-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">
        {t('emailVerificationRequired')}
      </span>
      <button
        onClick={showModal}
        className="text-xs text-brand-600 underline font-medium hover:text-brand-700 transition"
      >
        {t("verifyNow")}
      </button>
    </div>
  );
};

export default VerifyNotice;
